import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import { ContactProvider } from "@/context/ContactProvider.context";
import { ReserveProvider } from "@/context/ReserveProvider.context";

import i18n from "../../i18n";
import ContactModalComponent from "../contact/ContactModal.component";
import ReserveModalComponent from "../reserve/ReserveModal.component";

const VideoScreen: React.FC = () => {
  const { t } = i18n;

  return (
    <Container fluid className="videoScreenContainer">
      <video autoPlay loop muted playsInline className="pakville-video">
        <source
          src="https://cdn.pakville.ca/videos/Homepage_Hero_01.mp4"
          type="video/mp4"
        />
      </video>
      <Container className="videoScreenContentContainer">
        <Row className="d-flex align-items-center">
          <Col
            className="rounded videoScreenInnerContentContainer"
            lg={{ span: 6 }}
            xs={12}
          >
            <h1>
              {t("Building a Sustainable Future")}
              <br />
              {t("With PakVille™ Revolutionary Modular Buildings")}
            </h1>

            <div className="d-flex mt-4 justify-content-between align-items-center gap-4">
              <ContactProvider>
                <ContactModalComponent
                  btnClass="flex-grow-1 flex-shrink-1 flex-basis-0 p-2"
                  btnVariant="primary"
                />
              </ContactProvider>

              <ReserveProvider>
                <ReserveModalComponent
                  btnClass="flex-grow-1 flex-shrink-1 flex-basis-0 p-2"
                  btnVariant="outline-primary"
                />
              </ReserveProvider>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default VideoScreen;
